import { Tabs } from '@chakra-ui/react';
import CurrentOptions from './options/current-options';
import AddOptions from './options/add-options';

interface Props {
  workspaceId: number;
  fieldId: number;
  onSuccess?: () => void;
}

export default function FieldOptions({ workspaceId, fieldId, onSuccess }: Props) {
  return (
    <Tabs.Root lazyMount w={'full'} defaultValue={'current-options'} size='lg'>
      <Tabs.List>
        <Tabs.Trigger value='current-options'>Current Options</Tabs.Trigger>
        <Tabs.Trigger value='new-options'>Add Options</Tabs.Trigger>
      </Tabs.List>
      <Tabs.Content value='current-options'>
        <CurrentOptions fieldId={fieldId} />
      </Tabs.Content>
      <Tabs.Content value='new-options'>
        <AddOptions workspaceId={workspaceId} fieldId={fieldId} onSuccess={onSuccess} />
      </Tabs.Content>
    </Tabs.Root>
  );
}
